// Decisions about signing in and out, kept free of the browser so they can be
// tested with Node's own runner (`npm test`) — this project has no test framework,
// and it is being retired, so it does not get one.

/**
 * Whether /login should start the sign-in instead of waiting for a click.
 *
 * `?sso=1` is how an impersonation link arrives: the sign-in host already holds a
 * session for the account, so the OAuth flow completes with no password and no
 * consent, and a button in between is one click for nothing. Hub, Write and OS
 * start on their own already. An `error` on the way back means the attempt has
 * been made, and starting again would loop.
 */
export function shouldStartSignIn(query) {
  return Boolean(query) && query.sso === '1' && !query.error;
}

/**
 * A path on this site to return to after signing in, or null.
 *
 * Refuses anything that is not a plain path — `//host` and `/\host` are read by
 * browsers as another origin — because the value comes from the address bar.
 */
export function safeNext(value) {
  if (typeof value !== 'string' || !value.startsWith('/')) return null;
  if (value.startsWith('//') || value.startsWith('/\\')) return null;
  return value;
}

/**
 * Where signing out sends the browser: the sign-in host's /logout, which ends its
 * session too and comes back to this site's /login.
 *
 * Ending only the local session left the sign-in host signed in, so the next visit
 * to any StreetLib platform — in a window used for an impersonation, the account
 * being impersonated — signed straight back in. Hub, Tools and Write already sign
 * out this way.
 */
export function logoutUrl({ authUrl, clientId, origin }) {
  const url = new URL(`${authUrl.replace(/\/$/, '')}/logout`);
  url.searchParams.set('client_id', clientId);
  url.searchParams.set('logout_uri', `${origin}/login`);
  return url.toString();
}
